import { render, staticRenderFns } from "./RbacTable.vue?vue&type=template&id=52f454f4"
import script from "./RbacTable.vue?vue&type=script&lang=js"
export * from "./RbacTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports